import { Loader } from '@googlemaps/js-api-loader'
import { mapStyles } from './map-styles'

const loader = new Loader({
	apiKey: 'AIzaSyCdq2RDtzASFBXtxZLlQoLz_Q7Bd7tXWuI',
	version: 'weekly',
	libraries: ['maps'],
})

;(async () => {
	const [{ Map }, { Marker }] = await Promise.all([
		loader.importLibrary('maps'),
		loader.importLibrary('marker'),
	])

	const mapEl = document.getElementById('map')
	if (!mapEl) return

	const position = { lat: 47.6558612, lng: -117.4217643 }

	const map = new Map(mapEl, {
		center: position,
		zoom: 17,
		styles: mapStyles,
	})

	const marker = new Marker({
		position,
		map,
	})

	const contentString =
		'<div class="inner-popout" _ngcontent-mhn-c33>' +
		'<h5 _ngcontent-evs-c33="">Propaganda Creative</h5>' +
		'<div _ngcontent-evs-c33="" class="content">' +
		`Propaganda Creative,<br _ngcontent-evs-c33=""> 123 S Wall St,<br _ngcontent-evs-c33=""> Spokane, WA 99201 <p _ngcontent-evs-c33="" class="clear"></p><a _ngcontent-evs-c33="" rel="noopener" target="_blank" href="https://g.page/nwpropaganda" class="btn directions"> Get Directions </a>` +
		'</div>' +
		'</div>'

	const infowindow = new google.maps.InfoWindow({
		content: contentString,
		ariaLabel: 'Propaganda Creative',
	})

	marker.addListener('click', () => {
		infowindow.open({
			anchor: marker,
			map,
		})
	})

	infowindow.open(map, marker)
})()
